import type { IconName } from "@omnabase/ui";

/** The admin area's pages on a phone (M11 round three): the tab bar holds at most five (the kit's TabBar rule), so Data jobs and the way back
 *  to the app live on the More page. The rail shows every page on wider screens. */
export const ADMIN_MORE: { id: string; label: string; icon: IconName; to: string }[] = [{ id: "jobs", label: "Data jobs", icon: "database", to: "/admin/data-jobs" }];
